import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  Button,
  Space,
  Popconfirm,
  message,
  Modal,
  DatePicker,
} from "antd";
import ReactDOM from "react-dom";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  PrinterOutlined,
} from "@ant-design/icons";

import EditStore from "views/admin/storeManagement/EditStore";
import ViewStore from "views/admin/storeManagement/ViewStore/ViewStore";
import EditLaundry from "views/admin/mainlaundryManagement/EditLaundry";
import ViewLaundry from "views/admin/mainlaundryManagement/ViewLaundry/ViewLaundry";
import EditRole from "views/admin/roleManagement/EditRole";
import ViewRole from "views/admin/roleManagement/ViewRole/ViewRole";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import ViewReports from "views/admin/reportGeneration/ViewReports/ViewReports";
import PrintRow from "./PrintRow";
import { useReactToPrint } from "react-to-print";
import { API_LIST_REPORTS } from "api/Reports";
import { API_DELETE_ROLE } from "api/role-management";
import { API_DELETE_REPORT } from "api/Reports";

const { Column } = Table;
// const { TextArea } = Input;

const ReportsTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const [searchName, setSearchName] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { RangePicker } = DatePicker;

  const tableRef = useRef();

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        minDate: startDate ? startDate.unix() : undefined,  // Convert to Unix format
  maxDate: endDate ? endDate.unix() : undefined,      // Convert to Unix format
        // minDate: startDate ? startDate.format("YYYY-MM-DD") : undefined,
        // maxDate: endDate ? endDate.format("YYYY-MM-DD") : undefined,
      };
      const newData = await API_LIST_REPORTS(params);
      console.log("reports", newData);
      setData(newData);
      setLoading(false);
      setPagination({ ...pagination, total: newData.total_orders }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, startDate, endDate]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };

  const handleEdit = (record) => {
    setSelectedStore(record);
    setEditModalVisible(true);
    navigate(`/admin/role/edit/${record._id}`, {
      state: { data: record },
    });
  };

  const handleView = (record) => {
    setSelectedStore(record);
    setViewModalVisible(true);
    navigate(`/admin/order-management/${record._id}`, {
      state: { data: record },
    });
  };

  const handleDelete = async (id) => {
    try {
      let q = await API_DELETE_REPORT(id);
      message.success(q?.message);
      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error deleting store:", error);
      message.error("Failed to delete Report");
    }
  };

  const handleEditModalOk = () => {
    // Implement edit store logic here
    console.log("Editing store:", selectedStore);
    setEditModalVisible(false);
  };

  const handleViewModalOk = () => {
    // Implement view store logic here
    console.log("Viewing store:", selectedStore);
    setViewModalVisible(false);
  };

  const handleModalCancel = () => {
    setEditModalVisible(false);
    setViewModalVisible(false);
  };

  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
  });

  // const calculateTotalRevenue = () => {
  //   return data?.orders?.reduce((total, order) => total + order.total_revenue, 0) || 0;
  // };

  const todayDate = moment().format("DD/MM/YYYY");
  console.log("todayDate", todayDate);
  return (
    <div>
      <div className=" mb-4 flex justify-between">
        <Space>
          <RangePicker
          placeholder={[t("Start Date"), t("End Date")]}
            onChange={(dates) => {
              setStartDate(dates ? dates[0] : null);
              setEndDate(dates ? dates[1] : null);
            }}
            style={{ width: 250 }}
          />
        </Space>
      </div>
      <div ref={tableRef}>
        <div className="print-date">
          {startDate &&
            "Front " +
              moment(startDate).format("DD/MM/YYYY") +
              " to " +
              moment(endDate).format("DD/MM/YYYY") +
              " "}
          {t("Income Report")}
        </div>
        <Table
          className="report-table"
          dataSource={data?.orders}
          pagination={pagination}
          loading={loading}
          onChange={handleTableChange}
          rowKey={(record) => record.id} // Assuming each record has a unique id
          rowClassName={getRowClassName} // Apply alternating row colors
          scroll={{ x: true }}
          summary={() => (
            <Table.Summary.Row>
              <Table.Summary.Cell colSpan={4} align="right">
                {t("Total Revenue")}
              </Table.Summary.Cell>
              <Table.Summary.Cell>
                {Number(data?.total_revenue).toFixed(2)}
              </Table.Summary.Cell>
              <Table.Summary.Cell>
                <Button
                  type="primary"
                  className="action-buttons"
                  icon={<PrinterOutlined />}
                  onClick={handlePrint}
                  style={{ backgroundColor: "orange", borderColor: "orange" }}
                >
                  {t("Print Report")}
                </Button>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          )}
        >
          <Column
            title={t("sr#")}
            dataIndex="plan_title"
            key="plan_title"
            render={(text, record, index) => index + 1}
          />
          <Column
            title={t("Delivery Date")}
            dataIndex="order_delivery_time"
            key="order_delivery_time"
            render={(text, record) =>
              moment
                .unix(record.order_delivery_time?.from)
                .format("DD/MM/YYYY")
              //    +
              // " - " +
              // moment.unix(record.order_delivery_time?.to).format("DD/MM/YYYY")
            }
          />
          <Column
            title={t("Order By")}
            dataIndex="first_name"
            key="first_name"
            render={(text, record, index) =>
              record?.order_user_info?.first_name +
              " " +
              record?.order_user_info?.last_name
            }
          />
          <Column
            title={t("Quantity")}
            dataIndex="total_items"
            key="total_items"
            render={(text, record) => record?.invoice_details?.total_items}
          />
          <Column
            title={t("Total")}
            dataIndex="total"
            key="total"
            render={(text, record) =>
              Number(record?.invoice_details?.total_amount).toFixed(2)
            }
          />
          <Column
            className="action-buttons"
            title={t("Actions")}
            key="actions"
            render={(text, record) => (
              <div className="action-buttons">
                {/* <Button
                  type="primary"
                  icon={<PrinterOutlined />}
                  onClick={() => handlePrint(record)}
                ></Button> */}
                {/* <Popconfirm
                  title="Are you sure to delete this Report?"
                  onConfirm={() => handleDelete(record?._id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    type="danger"
                    icon={<DeleteOutlined />}
                    style={{ border: "1px solid #d9d9d9", marginLeft: "5px" }}
                  ></Button>
                </Popconfirm> */}
                <Button
                  type="default"
                  icon={<EyeOutlined />}
                  onClick={() => handleView(record)}
                  style={{ marginLeft: "5px" }}
                ></Button>
              </div>
            )}
          />
        </Table>
      </div>
      {/* Edit Store Modal */}
      <Modal
        key={selectedStore?._id}
        visible={editModalVisible}
        onOk={handleEditModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "65rem" }}
      >
        <EditRole data={selectedStore} />
      </Modal>
      {/* View Store Modal */}
      <Modal
        key={selectedStore?._id}
        visible={viewModalVisible}
        onOk={handleViewModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "60rem" }}
      >
        <ViewReports data={selectedStore} />
      </Modal>
    </div>
  );
};

export default ReportsTable;
